/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import {PassageiroListComponent} from "./passageiro-list/passageiro-list.component";
import {PassageiroFormComponent} from "./passageiro-form/passageiro-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class PassageirosRoutingModule {}

export const passageirosRoutes: any[] = [
    {
        path: '',
        component: PassageiroListComponent
    },{
        path: editRoute + '/:id',
        component: PassageiroFormComponent
    },{
        path: newRoute,
        component: PassageiroFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/passageiros/passageiros-routing.module.ts
 **/